module.exports = __webpack_public_path__ + "static/media/person-dolly-empty.eec9beba.svg";